import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, change, formValueSelector} from 'redux-form';
import {InputField, DropdownField} from '../../../../common/components/form';
import {toFloat} from '../../../../common/util/fieldsNormalization';
import {Card, Grid, Dropdown, Checkbox, Radio} from 'semantic-ui-react';
import {MASTER_VEHICLE_FORM} from '../../../../common/forms';
import {getOptions, getLimitedOptions, getClassWithSubClass} from './helper';
import {findIndex} from 'lodash';
import './editProductData.scss';
import {getTransmission, cilindrajeFit} from '../../../utils';

const cabinTypeOptions = [
  {'text': 'Cabina Simple', 'value': 'CS'},
  {'text': 'Cabina Doble', 'value': 'CD'},
  {'text': 'No Aplica', 'value': ''},
];

const securityCheck = [
  {'text': 'Mas de 4 Bolsas de Aire(Airbag)  ', 'value': 'bolsas'},
  {'text': 'Protección de Peatones  ', 'value': 'peatones'},
  {'text': 'Luces de Encendido  ', 'value': 'luces'},
  {'text': 'Freno Asistido de Emergencia  ', 'value': 'freno'},
  {'text': 'Ensayo de Poste  ', 'value': 'ensayo'},
];

class ProductData extends Component {
  constructor(props) {
    super(props);
    this.handleInputCilindrajeChange = this.handleInputCilindrajeChange.bind(this);
    this.state = {
      'selectedValues': [],
    };
  }

  componentDidMount() {
    const {esGoshiValue} = this.props;
    if (esGoshiValue === 'undefined' || esGoshiValue === null || esGoshiValue === '') {
      this.props.change('masterVehicle', 'esGoshi', false);
    }
  }

  render() {
    const {classesList, addProduct, jdeList, editKatashikiAndSfxTDE, code} = this.props;
    return (
      <div>
        <Card raised fluid className='vehicle-master-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Katashiki</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='katashiki'
                  component={InputField}
                  maxLength={30}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addProduct || (code && !editKatashikiAndSfxTDE)}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Sufijo Proveedor</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name='sfxProvider'
                  component={InputField}
                  maxLength={3}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addProduct}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
              <Grid.Column width={1}>
                <h4>Sufijo TDE</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  name='sfx'
                  component={InputField}
                  maxLength={3}
                  normalize={(value) => value.toUpperCase()}
                  disabled={!addProduct || (code && !editKatashikiAndSfxTDE)}
                  invalidMessage='Por favor, llene este campo'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Estado Vehículo</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  toggle
                  name='vehicleState'
                  component={this.renderCheckBox}
                  readOnly={!addProduct}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Descripción</h4>
              </Grid.Column>
              <Grid.Column width={10}>
                <Field
                  name='description'
                  component={InputField}
                  maxLength={50}
                  normalize={(value) => value.toUpperCase()}
                  disabled
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Aire Acondicionado</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  toggle
                  name='airConditioning'
                  component={this.renderCheckBox}
                  readOnly={!addProduct}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Modelo</h4>
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  name='modelName'
                  component={InputField}
                  normalize={(value) => {
                    this.updateDescription('modelName', value.toUpperCase());
                    return value.toUpperCase();
                  } }
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={5}>
                {this.renderCabinType()}
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Es Goshi</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                <Field
                  toggle
                  name='esGoshi'
                  component={this.renderCheckBox}
                  readOnly={!addProduct}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Categoría</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='category'
                  options={getLimitedOptions(jdeList.categoriesList, 'completeName', 20)}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Segmento</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='segment'
                  options={getOptions(jdeList.segmentsList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Tracción</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='subSegment'
                  options={getOptions(jdeList.subSegmentsList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Familia</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='family'
                  options={getOptions(jdeList.familiesList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Tracción V.</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='traction'
                  options={getOptions(jdeList.tractionList, 'completeName')}
                  component={this.renderDropdownAndUpdateDescription}
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Transmisión</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='transmission'
                  options={getOptions(jdeList.transmissionsList, 'completeName')}
                  component={this.renderDropdownAndUpdateDescription}
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Número de Puertas</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='doorsNumber'
                  options={getOptions(jdeList.doorsList, 'completeName')}
                  component={this.renderDropdownAndUpdateDescription}
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Pasajeros</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='passengers'
                  options={getOptions(jdeList.passengersList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Combustible</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='fuel'
                  options={getOptions(jdeList.fuelsList, 'completeName')}
                  component={this.renderDropdownAndUpdateDescription}
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>País Origen</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='country'
                  options={getOptions(jdeList.originsList, 'name')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Híbrido</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='hybrid'
                  options={getOptions(jdeList.hybridList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Cilindraje (cm3)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='cilindraje'
                  component={InputField}
                  type='number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  onChange={this.handleInputCilindrajeChange}
                  disabled={!addProduct}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00'
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Caballaje (HP)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='potency'
                  component={InputField}
                  type='Number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addProduct}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Clase SRI</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='sriClass'
                  options={getOptions(jdeList.sriList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Subclase SRI</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='sriType'
                  options={getOptions(jdeList.sriList, 'completeName')}
                  component={DropdownField}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Clase SRI - SubClase SRI Archivo</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='vehClass'
                  options={getClassWithSubClass(classesList, 'sequence')}
                  component={this.renderDropdownClasses}
                  placeholder='Seleccione una opción'
                  disabled={!addProduct}
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Adicionales</h4>
              </Grid.Column>
              <Grid.Column width={2}>
                {this.renderAditionalType()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </div>
    );
  }

  getModels() {
    const {vehiclesModelsList} = this.props;
    return vehiclesModelsList.map((model) => {
      return {'text': model.name, 'value': model.id};
    });
  }

  renderAditionalType() {
    const {addProduct} = this.props;
    return securityCheck.map((type, index) => {
      return <Field
        key={index}
        name='aditionals'
        component={this.renderSecurityCheckType}
        props={{'value': type.value, 'label': type.text}}
        readOnly={!addProduct}
      />;
    });
  }

  renderCheckBox = ({input, label, readOnly}) => {
    return (
      <Checkbox
        label={label}
        checked={input.value === true}
        onChange={(e, {checked}) => {
          this.updateDescription(input.name, checked);
          return input.onChange(checked);
        }}
        readOnly={readOnly}
      />
    );
  };

  renderSecurityCheckType= ({input, label, readOnly, value}) => {
    return (
      <Checkbox
        label={label}
        value={value}
        checked={input.value.includes(value)}
        onChange= {(e, {checked, value}) => {
          const newValue = checked ? [...input.value, value] : input.value.filter((v) => v !== value);
          return input.onChange(newValue);
        }}
        readOnly={readOnly}
      />
    );
  }

  renderCabinType() {
    const {addProduct} = this.props;
    return cabinTypeOptions.map((type, index) => {
      return <Field
        key={index}
        name='cabinType'
        component={this.renderRadioButton}
        props={{'value': type.value, 'label': type.text}}
        disabled={!addProduct}
      />;
    });
  }

  renderRadioButton = (field) => {
    return (
      <Radio
        className="mr-radiobutton"
        value={field.value}
        label={field.label}
        checked={field.value === field.input.value}
        onChange={(e, {value}) => {
          this.updateDescription(field.input.name, value);
          return field.input.onChange(value);
        }}
        disabled={field.disabled}
      />
    );
  };

  renderCheckButton = (field) => {
    return (
      <Checkbox
        className="mr-radiobutton"
        value={field.value}
        label={field.label}
        checked={field.value === field.input.value}
        onChange={(e, {value}) => {
          this.updateDescription(field.input.name, value);
          return field.input.onChange(value);
        }}
        disabled={field.disabled}
      />
    );
  };

  renderDropdownAndUpdateDescription = (field) => {
    return (
      <Dropdown selection
        options={field.options}
        value={field.input.value}
        search
        onChange={(e, data) => {
          if (field.input.name === 'vehicleId') {
            const modelName = this.getModelName(data.value);
            this.props.change('masterVehicle', 'vehicleName', modelName);
          }

          this.updateDescription(field.input.name, data.value);
          return field.input.onChange(data.value);
        }}
        placeholder='Seleccione una opción'
        style={!field.input.value && field.required ? {'borderColor': 'red', 'backgroundColor': '#fff5f6'} : null}
        disabled={field.disabled}
      />
    );
  }

  renderDropdownClasses = (field) => {
    return (
      <Dropdown selection
        options={field.options}
        value={field.input.value}
        onChange={(e, data) => {
          const selectedOption = field.options && field.options.find((el) => el.value === data.value);
          if (selectedOption && selectedOption.text) {
            this.props.change('masterVehicle', 'vehClassDescription', selectedOption.text);
          }
          return field.input.onChange(data.value);
        }}
        placeholder='Seleccione una opción'
        style={!field.input.value && field.required ? {'borderColor': 'red', 'backgroundColor': '#fff5f6'} : null}
        disabled={field.disabled}
      />
    );
  }

  handleInputCilindrajeChange(event, value) {
    this.updateDescription('cilindraje', value);
  }

  updateAditionals(value) {
    this.props.change('masterVehicle', 'aditionals', [value]);
  }
  // eslint-disable-next-line max-statements
  updateDescription(field, value) {
    const {airConditioningValue, cilindrajeValue, doorsNumberValue, cabinTypeValue, tractionValue,
      transmissionValue, fuelValue, modelName} = this.props;

    const model = this.getValueForDescription(field === 'modelName' ? `${value} ` : modelName);

    let airConditioning = field === 'airConditioning' ? value : airConditioningValue;
    airConditioning = airConditioning ? ` ${'AC'}` : '';

    const cilindraje = this.getValueForDescription(field === 'cilindraje' ? ` ${value}` : ` ${cilindrajeValue}`);

    const cabinType = this.getValueForDescription(field === 'cabinType' ? value : cabinTypeValue);

    const doorsNumberName = this.getDescriptionName(field === 'doorsNumber' ? value : doorsNumberValue);
    const doorsNumber = this.getValueForDescription(
      doorsNumberName ? doorsNumberName.trim().replace(/ /g, '').substring(0, 2) : '');

    const tractionName = this.getDescriptionName(field === 'traction' ? value : tractionValue);
    const traction = this.getValueForDescription(tractionName);

    const transmissionName = this.getDescriptionName(field === 'transmission' ? value : transmissionValue);
    const transmission = this.getValueForDescription(transmissionName);

    const fuelName = this.getDescriptionName(field === 'fuel' ? value : fuelValue);
    const getFuel = this.getValueForDescription(fuelName);
    const fuel = getFuel.includes('GASOLINA') ? '' : getFuel;

    const description =
    `${model}${airConditioning}${cilindrajeFit(cilindraje)}${doorsNumber}${cabinType}` +
    `${traction}${getTransmission(transmission)}${fuel}`;
    this.props.change('masterVehicle', 'description', description.trim());
  }

  getModelName(modelId) {
    if (!modelId) {
      return '';
    }
    const {vehiclesModelsList} = this.props;
    const index = findIndex(vehiclesModelsList, {'id': modelId});
    if (index === -1) {
      return '';
    }
    return vehiclesModelsList[index].name;
  }

  getDescriptionName(value) {
    const array = value.split('-');
    return array[1];
  }

  getValueForDescription(value) {
    if (!value || value === ' null' || value === 'NO APLICA' || value === 'NO' ||
      value === 'BLANCO' || value === 'BL') {
      return '';
    }
    return ` ${value}`;
  }
}

const mapStateToProps = (state) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const airConditioningValue = formValues(state, 'airConditioning');
  const cilindrajeValue = formValues(state, 'cilindraje');
  const doorsNumberValue = formValues(state, 'doorsNumber');
  const cabinTypeValue = formValues(state, 'cabinType');
  const tractionValue = formValues(state, 'traction');
  const transmissionValue = formValues(state, 'transmission');
  const fuelValue = formValues(state, 'fuel');
  const modelName = formValues(state, 'modelName');
  const aditionalsValue = formValues(state, 'aditionals');
  const esGoshiValue = formValues(state, 'esGoshi');
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'vehiclesModelsList': state.vehiclesModels.vehicles,
    'jdeList': state.masterVehicle.jdeList,
    'editKatashikiAndSfxTDE': state.form.masterVehicle.editKatashikiAndSfxTDE,
    'classesList': state.form.masterVehicle.classesList,
    airConditioningValue,
    cilindrajeValue,
    doorsNumberValue,
    cabinTypeValue,
    tractionValue,
    transmissionValue,
    fuelValue,
    modelName,
    aditionalsValue,
    esGoshiValue,
  };
};

export default connect(mapStateToProps, {
  change,
})(ProductData);
